import React from "react";
import { NewsShortInfo } from "@modules/study/common/news";
import Link from "next/link";
import styles from "./top_section.module.scss";
import { upperFirstLetter } from "@unisearch/helpers";

export const GalleryDetailTopSection = ({ newsDetails }) => {
  const shortInfo = {
    author: newsDetails?.author,
    publishDate: newsDetails?.publishDate,
    totalView: newsDetails?.totalView,
    totalComment: newsDetails?.totalComment,
    id: newsDetails?.newsId,
  };

  return (
    <section className={styles.blog_hero_simple}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.tag_btn}>
            {newsDetails?.newsFormat
              ? upperFirstLetter(newsDetails?.newsFormat)
              : ""}
          </div>
          <h2 className={styles.title}>{newsDetails?.newsTitle}</h2>
          <NewsShortInfo data={shortInfo} />
        </div>
      </div>
    </section>
  );
};

export default GalleryDetailTopSection;
